<template>
  <v-layout xs12 pa-1 row wrap>
    <v-switch
      hide-details
      v-model="skipWeekends"
      @change="changeSkipWeekends"
      label=" Skip Weekends"
    ></v-switch>
    <v-flex shrink pl-2>
      <v-switch hide-details v-model="same" @change="changeSame" label=" Same"></v-switch>
    </v-flex>
    <p style="color: red;" v-if="errorOutbound != null">{{errorOutbound}}&nbsp;</p>
    <p style="color: red;" v-if="errorReturn != null">{{errorReturn}}&nbsp;</p>
    <p
      style="color: red;"
      v-if="repeatService != null && repeatService.repeatServiceModel.trip_a != null && errorForDayOfWeekTimeList(repeatService.repeatServiceModel.trip_a) != null"
    >{{errorForDayOfWeekTimeList(repeatService.repeatServiceModel.trip_a)}}&nbsp;</p>
    <p
      style="color: red;"
      v-if="repeatService != null && repeatService.repeatServiceModel.trip_b != null && errorForDayOfWeekTimeList(repeatService.repeatServiceModel.trip_b) != null"
    >{{errorForDayOfWeekTimeList(repeatService.repeatServiceModel.trip_b)}}&nbsp;</p>
    <p
      style="color: red;"
      v-if="repeatTripDefinition != null && errorForDayOfWeekTimeList(repeatTripDefinition) != null"
    >{{errorForDayOfWeekTimeList(repeatTripDefinition)}}&nbsp;</p>
    <p style="color: red;" v-if="repeatTripDefinition != null">{{errorOutbound}}&nbsp;</p>
    <v-flex xs12 pt-2>
      <v-layout row>
        <v-flex xs3></v-flex>
        <v-flex v-if="repeatTripDefinition == null" pl-3 xs4>
          <h5>Outbound</h5>
        </v-flex>
        <v-flex v-if="repeatTripDefinition == null" pl-3 xs4>
          <h5>Return</h5>
        </v-flex>
        <v-flex v-if="repeatTripDefinition != null" pl-3 xs4>
          <h5>Time</h5>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-layout py-1 px-2 align-center v-for="( day, index ) in dayArray">
      <v-flex pt-2 xs3>
        <p style="font-size: 13px;">{{ days[index] }}</p>
      </v-flex>
      <v-flex v-if="repeatTripDefinition != null" pl-3 xs4>
        <SimpleTextInput
          :disabled="disableWeekend(index)"
          @input="updateTripTimes"
          v-model="repeatTripDefinition.day_of_week_times_list[index].time"
          @blur="function() {}"
          :maxlength="5"
        ></SimpleTextInput>
      </v-flex>
      <v-flex v-if="repeatService != null" pl-3 xs4>
        <SimpleTextInput
          :disabled="disableWeekend(index)"
          @input="updateTripATimes"
          v-model="repeatService.repeatServiceModel.trip_a.day_of_week_times_list[index].time"
          @blur="function() {}"
          :maxlength="5"
        ></SimpleTextInput>
      </v-flex>
      <v-flex v-if="repeatService != null" pl-3 xs4>
        <SimpleTextInput
          v-if="repeatService.repeatServiceModel.trip_b != null"
          @input="updateTripBTimes"
          :disabled="!repeatService.hasReturnTrip() || disableWeekend(index)"
          v-model="repeatService.repeatServiceModel.trip_b.day_of_week_times_list[index].time"
          @blur="function() {}"
          :maxlength="5"
        ></SimpleTextInput>
        <SimpleTextInput
          v-else
          @input="updateTripBTimes"
          :disabled="true"
          @blur="function() {}"
          :maxlength="5"
        ></SimpleTextInput>
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import SimpleTextInput from "@/components/widget/input/SimpleTextInput.vue";

import { RepeatService } from "@/components/util/RepeatService.js";

export default {
  name: "DayOfWeekTimes",
  components: {
    SimpleTextInput,
  },
  model: {
    prop: "content",
    event: "input",
  },
  props: {
    content: String,
    label: String,
    required: Boolean,
    error: String,
    repeatService: Object,
    repeatTripDefinition: Object,
    errorOutbound: String,
    errorReturn: String,
  },
  data() {
    return {
      menu: false,
      skipWeekends: false,
      same: false,
    };
  },
  computed: {
    dayOfWeekTimes: function () {
      // return RepeatS;
    },
    days: function () {
      return RepeatService.days();
    },
    dayArray: function () {
      return RepeatService.dayArray();
    },
  },
  methods: {
    errorForDayOfWeekTimeList(repeatTripDefinition) {
      if (repeatTripDefinition.day_of_week_times_errors != null) {
        var errString = "";
        if (repeatTripDefinition.day_of_week_times_errors.time != null) {
          errString += repeatTripDefinition.day_of_week_times_errors.time;
        }

        if (repeatTripDefinition.day_of_week_times_errors.day_of_week != null) {
          errString +=
            " - " + repeatTripDefinition.day_of_week_times_errors.day_of_week;
        }

        return errString;
      }

      return null;
    },
    updateTripTimes(text) {
      this.updateTripTimesSame(
        text,
        this.repeatTripDefinition.day_of_week_times_list
      );
    },
    updateTripATimes(text) {
      this.updateTripTimesSame(
        text,
        this.repeatService.repeatServiceModel.trip_a.day_of_week_times_list
      );
    },
    updateTripBTimes(text) {
      this.updateTripTimesSame(
        text,
        this.repeatService.repeatServiceModel.trip_b.day_of_week_times_list
      );
    },
    updateTripTimesSame(text, dayOfWeekTimesList) {
      if (!this.same) {
        return;
      }

      dayOfWeekTimesList[0].time = text;
      dayOfWeekTimesList[1].time = text;
      dayOfWeekTimesList[2].time = text;
      dayOfWeekTimesList[3].time = text;
      dayOfWeekTimesList[4].time = text;

      if (this.skipWeekends) {
        return;
      }

      dayOfWeekTimesList[5].time = text;
      dayOfWeekTimesList[6].time = text;
    },
    disableWeekend(index) {
      // console.log(index);
      return index >= 5 && this.skipWeekends;
    },
    changeSkipWeekends(skip) {
      // console.log(skip);
      this.skipWeekends = skip;

      if (skip) {
        if (
          this.repeatService != null &&
          this.repeatService.repeatServiceModel.trip_a != null
        ) {
          this.repeatService.repeatServiceModel.trip_a.day_of_week_times_list[5].time = null;
          this.repeatService.repeatServiceModel.trip_a.day_of_week_times_list[6].time = null;
        }

        if (
          this.repeatService != null &&
          this.repeatService.repeatServiceModel.trip_b != null
        ) {
          this.repeatService.repeatServiceModel.trip_b.day_of_week_times_list[5].time = null;
          this.repeatService.repeatServiceModel.trip_b.day_of_week_times_list[6].time = null;
        }
      } else {
        if (this.repeatService != null) {
          this.repeatService.repeatServiceModel.trip_a.day_of_week_times_list[5].time = null;
          this.repeatService.repeatServiceModel.trip_a.day_of_week_times_list[6].time = null;
        }

        if (
          this.repeatService != null &&
          this.repeatService.repeatServiceModel.trip_b != null
        ) {
          this.repeatService.repeatServiceModel.trip_b.day_of_week_times_list[5].time = null;
          this.repeatService.repeatServiceModel.trip_b.day_of_week_times_list[6].time = null;
        }
      }
    },
    changeSame(same) {
      this.same = same;
    },
    valid() {
      console.log(this.error);

      if (this.error == null) {
        return true;
      }

      return this.error;
    },
    updateSelf(content) {
      this.menu = false;
      this.$emit("input", content);
      this.$emit("submitted");
      console.log("date selected");
    },
    focused() {
      console.log("focused");
      this.$emit("focused");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
</style>
